import { actions as actions$1 } from '@grandvisionhq/state';

const loadReviewWrite = actions$1.action('LOAD_REVIEW_WRITE', actions$1.payload());
const loadReviewSnippet = actions$1.action('LOAD_REVIEW_SNIPPET', actions$1.payload());
const loadReviewDisplay = actions$1.action('LOAD_REVIEW_DISPLAY', actions$1.payload());
const updateReviewDisplay = actions$1.action('UPDATE_REVIEW_DISPLAY', actions$1.payload());

export { loadReviewDisplay, loadReviewSnippet, loadReviewWrite, updateReviewDisplay };
//# sourceMappingURL=actions.js.map
